import { HttpClient } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';
import { LogInstanceToken, LogInterface } from '@evorait/pace-logging';
import { Observable, throwError } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import { ENDPOINTS } from '../../enums/endpoints.enum';
import { OdataConfigInterface } from '../../interfaces/odata-config.interface';
import { OdataResponse } from '../../interfaces/online-only.interface';
import { ConfigModel, ODataConfigModel } from '../../models/low-level/config.model';
import { UriUtilitiesService } from '../uri-utilities/uri-utilities.service';
import { isDefined } from '../../utilities/is-defined';
import { ODataUtilities } from '../../utilities/odata-utilities';
import { UserMasterInstanceToken, UserMasterInterface } from '../../interfaces/user-master.interface';

@Injectable({
    providedIn: 'root',
})
export class OdataConfigService implements OdataConfigInterface {
    public constructor(
        @Inject(LogInstanceToken) private readonly log: LogInterface,
        private readonly uriUtilities: UriUtilitiesService,
        private readonly http: HttpClient,
        @Inject(UserMasterInstanceToken) private readonly userMasterService: UserMasterInterface,
    ) {}

    /**
     * Load the raw config values.
     */
    public getConfig(): Observable<ConfigModel[]> {
        const query = this.userMasterService.setSalesOrgAndPlantForUrl(
            this.uriUtilities.getUriForContent() + ENDPOINTS.ConfigSet,
        );

        return this.http.get<OdataResponse<ODataConfigModel>>(query).pipe(
            map((response) =>
                ODataUtilities.transformResponseDataToArray(response.d)
                    .map((c: ODataConfigModel) => ConfigModel.fromOData(c))
                    .filter(isDefined),
            ),
            catchError((err) => {
                this.log.error('getConfig() - request error:  ' + JSON.stringify(err, Object.getOwnPropertyNames(err)));
                return throwError(err);
            }),
        );
    }

    public getConfigState(): Observable<Record<string, string>> {
        const query = this.userMasterService.setSalesOrgAndPlantForUrl(
            this.uriUtilities.getUriForContent() + ENDPOINTS.ConfigSet,
        );

        return this.http.get<OdataResponse<ODataConfigModel>>(query).pipe(
            map((response) => {
                const configState: Record<string, string> = {};
                ODataUtilities.transformResponseDataToArray(response.d).forEach((c: ODataConfigModel) => {
                    configState[c.Key] = c.Value;
                });

                return configState;
            }),
            catchError((err) => {
                this.log.error('getConfig() - request error:  ' + JSON.stringify(err, Object.getOwnPropertyNames(err)));
                return throwError(err);
            }),
        );
    }
}
